import React, { FC, ReactNode, RefObject, MouseEventHandler } from 'react';
import '../../styles/components/button.scss';

interface ButtonProp {
  className?: string;
  title?: string;
  disabled?: boolean;
  icon?: ReactNode;
  buttonRef?: RefObject<HTMLButtonElement>;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export const Button: FC<ButtonProp> = ({
  className,
  title,
  disabled,
  icon,
  buttonRef,
  onClick,
}) => (
  <button
    disabled={disabled}
    className={`button ${className}`}
    ref={buttonRef}
    onClick={onClick}
  >
    {icon}{title}
  </button>


);
